(function () {
    'use strict';
    radaDutyFlushController.$inject = ['dutyFlushService'];
    angular 
        .module("app.dutyFlush")
        .component("radaDutyFlush", {
            controller: radaDutyFlushController,
            bindings: {
                initialNumberOfOutlets: '@',
                initialDutyFlushingFrequency: '@',
                initialFlushingDuration: '@',
                initialLogCheckingDurationPerOutlet: '@',
                initialSalary: '@',
                initialWorkingWeek: '@',
                initialSalaryFrequency:'@',
                initialSector:'@',
                currency: '@',
                numberOfOutlets: '@',
                numberOfOutletsDescription: '@',
                dutyFlushingFrequency: '@',
                dutyFlushingFrequencyDescription: '@',
                flushingDuration: '@',
                flushingDurationDescription: '@',
                locale: '@',
                pageId: '@',
                logCheckingDurationPerOutlet: '@',
                logCheckingDurationPerOutletDescription: '@',
                submissionText: '@',
                sector: '@',
                salary: '@',
                salaryFrequency: '@',
                workingWeek: '@',
                workingWeekDescription: '@',
                description: '@',
                heading:'@',
                yourFacility: '@',
                yourTeam: '@',
                time: '@',
                people: '@',
                cost: '@',
                perAnnum: '@',
                peopleRequired: '@',
                timeDescription: '@',
                emailLabel: '@',
                optInLabel: '@',
                send: '@',
                introduction: '@'
            }, // components are limited to isolated scope
            templateUrl: "/client/app/duty-flush/duty-flush.html",
            controllerAs: 'vm'
        });

    /* @ngInject */
    function radaDutyFlushController(dutyFlushService) {
        var vm = this;
        vm.switchingProducts = false;
        vm.isValidHelper = isValidHelper;
        vm.isInvalidHelper = isInvalidHelper;
        vm.compute = compute;
        vm.submit = submit;
        vm.submitted = false;
        vm.sectors = [];
        vm.salaryFrequencies = [];
        vm.changeLogCheckingDurationPerOutlet = changeLogCheckingDurationPerOutlet;
        vm.changeFlushingDuration = changeFlushingDuration;
        vm.changeDutyFlushingFrequency = changeDutyFlushingFrequency;
        vm.changeSalary = changeSalary;
        vm.changeNumberOfOutlets = changeNumberOfOutlets;

        vm.$onInit=function() {
            vm.model = {
                "numberOfOutlets" : parseInt(vm.initialNumberOfOutlets,10),
                "dutyFlushingFrequency" : parseInt(vm.initialDutyFlushingFrequency,10),
                "flushingDuration" : parseInt(vm.initialFlushingDuration,10),
                "logCheckingDurationPerOutlet": parseInt(vm.initialLogCheckingDurationPerOutlet,10),
                "sector" : vm.initialSector,
                "salary": parseInt(vm.initialSalary,10),
                "salaryFrequency": vm.initialSalaryFrequency,
                "workingWeek": parseInt(vm.initialWorkingWeek,10),
                "time": 0,
                "people": 0,
                "cost": 0,
                "email":"",
                "consent": false,
                "locale": vm.locale,
                "pageId": vm.pageId
                }

                dutyFlushService.getSectors(vm.pageId).then(function(resp) {
                if (resp) {
                    vm.sectors = resp;
                    vm.model.sector = vm.sectors[0];
                    vm.compute();
                }

                if (vm.locale ==='de')
                {
                    vm.salaryFrequencies= [
                        {"name":"Pro Jahr",
                        "id": "1"},
                        {"name":"Pro Monat",
                        "id": "2"},
                        {"name":"Pro Woche",
                        "id": "3"},
                        {"name":"Pro Stunde",
                        "id": "4"}];
                }
                if (vm.locale ==='nl')
                {
                    vm.salaryFrequencies= [
                        {"name":"Per Jaar",
                        "id": "1"},
                        {"name":"Per Maand",
                        "id": "2"},
                        {"name":"Per Week",
                        "id": "3"},
                        {"name":"Per Uur",
                        "id": "4"}];
                }
                if (vm.locale ==='en')
                {
                    vm.salaryFrequencies= [
                        {"name":"Per Annum",
                        "id": "1"},
                        {"name":"Per Month",
                        "id": "2"},
                        {"name":"Per Week",
                        "id": "3"},
                        {"name":"Per Hour",
                        "id": "4"}];
                }
               
            });
        };

        function isValidHelper(field) {
            var required = field.$validators.required !== undefined;

            return (field.$valid && field.$pristine && required) ||
                (field.$valid && field.$dirty) ||
                (field.$valid && field.$touched) || (field.$valid && vm.submitted);
        }

        function isInvalidHelper(field) {
            return (field.$invalid && field.$dirty) ||  (field.$invalid && field.$touched) ||
                (field.$invalid && vm.submitted);
        }

        function compute() {
            vm.model.time = (vm.model.numberOfOutlets * vm.model.dutyFlushingFrequency * (vm.model.flushingDuration + vm.model.logCheckingDurationPerOutlet)) / 60 / 60;
            vm.model.people = vm.model.time / vm.model.workingWeek;

            if (vm.model.salaryFrequency ==="1") {
                vm.model.cost = vm.model.salary * vm.model.people;
            }
            if (vm.model.salaryFrequency ==="2") {
                vm.model.cost = vm.model.salary * vm.model.people * 12;
            }
            if (vm.model.salaryFrequency ==="3") {
                vm.model.cost = vm.model.salary * vm.model.people * 52;
            }
            if (vm.model.salaryFrequency ==="4") {
                vm.model.cost = vm.model.salary * vm.model.people * 52 * vm.model.workingWeek;
            }
        }

        function changeDutyFlushingFrequency (amount) {
            vm.model.dutyFlushingFrequency = vm.model.dutyFlushingFrequency + amount;
        }
        function changeSalary(amount) {
            vm.model.salary = vm.model.salary + amount;
        }

        function changeFlushingDuration (amount) {
            vm.model.flushingDuration = vm.model.flushingDuration + amount;
        }
        function changeNumberOfOutlets(amount) {
            vm.model.numberOfOutlets = vm.model.numberOfOutlets + amount;
        }

        function changeLogCheckingDurationPerOutlet (amount) {
            vm.model.logCheckingDurationPerOutlet = vm.model.logCheckingDurationPerOutlet + amount;
        }

        function submit() {
            dutyFlushService.createFormRecord(vm.model).then(function ()
            {
               vm.submitted = true}
            );
        }

    }
})();